import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenderLabelPipe } from 'src/app/common/pipes/render-label/render-label.pipe';
import { ButtonComponent } from '../../atoms/button/button.component';
import { Observable } from 'rxjs';
import { ConfirmationDialogService } from 'src/app/common/services/confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [CommonModule, RenderLabelPipe, ButtonComponent],
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  headerTitle$: Observable<string>;
  headerName$: Observable<string>;
  message$: Observable<string>;
  content$: Observable<string>;
  isDefault$: Observable<boolean>;
  isCustomMsg$: Observable<boolean>;
  confirmText$: Observable<string>;
  cancelText$: Observable<string>;
  type$: Observable<string>;

  @Input() showClose: boolean = true;
  @Output() confirm = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  headerTitle: string = '';
  headerName: string = '';
  message: string = '';
  content: string = '';
  isDefault: boolean = true;
  isCustomMsg: boolean = false;
  confirmText: string = '';
  cancelText: string = '';
  dialogType: string = '';
  buttonClass: string = '';

  constructor(public confirmationDialogService: ConfirmationDialogService) {
    this.headerTitle$ = this.confirmationDialogService.headerTitle$;
    this.headerName$ = this.confirmationDialogService.headerName$;
    this.message$ = this.confirmationDialogService.message$;
    this.content$ = this.confirmationDialogService.content$;
    this.isDefault$ = this.confirmationDialogService.isDefault$;
    this.isCustomMsg$ = this.confirmationDialogService.isCustomMsg$;
    this.confirmText$ = this.confirmationDialogService.confirmText$;
    this.cancelText$ = this.confirmationDialogService.cancelText$;
    this.type$ = this.confirmationDialogService.type$;

    this.headerTitle$.subscribe((value) => {
      this.headerTitle = value;
    });

    this.headerName$.subscribe((value) => {
      this.headerName = value;
    });

    this.message$.subscribe((value) => {
      this.message = value;
    });

    this.content$.subscribe((value) => {
      this.content = value;
    });

    this.isDefault$.subscribe((value) => {
      this.isDefault = value;
    });

    this.isCustomMsg$.subscribe((value) => {
      this.isCustomMsg = value;
    });

    this.confirmText$.subscribe((value) => {
      this.confirmText = value;
    });

    this.cancelText$.subscribe((value) => {
      this.cancelText = value;
    });

    this.type$.subscribe((type) => {
      this.dialogType = `dialog-${type}`;
      this.buttonClass = this.getButtonClass(type);
    });
  }

  private getButtonClass(type: string): string {
    switch (type) {
      case 'danger':
        return 'btn-danger';
      case 'warning':
        return 'btn-warning';
      case 'info':
        return 'btn-info';
      default:
        return 'btn-primary';
    }
  }

  onConfirm() {
    this.confirmationDialogService.confirm();
    this.confirm.emit();
  }

  onCancel() {
    this.confirmationDialogService.cancel();
    this.dismissed.emit();
  }

  onClose() {
    this.confirmationDialogService.close();
    this.dismissed.emit();
  }

  onOverlayClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
